import * as AT from '../actions/_types';

const initialState = {
  hours: [],
  isFetching: false,
  isUpdating: false,
};

export default function activeHoursReducer(state = initialState, action) {
  switch (action.type) {
    case AT.ACTIVE_HOURS_FETCHING:
      return { ...state, isFetching: true };
    case AT.ACTIVE_HOURS_FETCHED:
      return { ...state, hours: action.payload, isFetching: false };
    case AT.ACTIVE_HOURS_UPDATING:
      return { ...state, isUpdating: true };
    case AT.ACTIVE_HOURS_UPDATED:
      return { ...state, hours: action.payload, isUpdating: false };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/state/reducers/active-hours.js